import Vue from "vue";
import VueRouter from "vue-router";
import GlobalGuards from "@/guards/Global";
import TheContainer from "@/containers/TheContainer";
const Page404 = () => import("@/views/errors/Page404");
const Page403 = () => import("@/views/errors/Page403");
const Page500 = () => import("@/views/errors/Page500");
const PageUnderConstruction = () =>
  import("@/views/errors/PageUnderConstruction");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Container",
    component: TheContainer,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "Home",
        meta: {
          requiresAuth: false,
          label: "صفحه اصلی",
        },
        component: () => import("@/views/pages/home"),
      },

      {
        path: "news",
        meta: {
          label: "اخبار",
          requiresAuth: false,
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/news/list",
        children: [
          {
            path: "list/:id?",
            name: "NewsList",
            meta: {
              requiresAuth: false,
              label: "لیست خبرها",
            },
            component: () => import("@/views/pages/news/List"),
          },
          {
            path: "details/:id",
            name: "NewsDetails",
            meta: {
              requiresAuth: false,
              label: "جزيیات خبرها",
            },
            component: () => import("@/views/pages/news/Details"),
          },
        ],
      },
      {
        path: "multiMedia",
        meta: {
          label: "چندرسانه‌ای",
          requiresAuth: false,
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/list",
        children: [
          {
            path: "list",
            name: "MultiMedia",
            meta: {
              requiresAuth: false,
              label: "چندرسانه‌ای",
            },
            component: () => import("@/views/pages/multiMedia"),
          },
          {
            path: "video/list",
            name: "VideoList",
            meta: {
              requiresAuth: false,
              label: "ویدیو",
            },
            component: () => import("@/views/pages/multiMedia/video"),
          },
          {
            path: "video",
            name: "Video",
            meta: {
              requiresAuth: false,
              label: "ویدیو",
            },
            component: () => import("@/views/pages/multiMedia/video/Video"),
          },
          {
            path: "video/details/:id",
            name: "VideoDetails",
            meta: {
              requiresAuth: false,
              label: "ویدیو",
            },
            component: () => import("@/views/pages/multiMedia/video/Details"),
          },
          {
            path: "podcast",
            name: "Podcast",
            meta: {
              requiresAuth: false,
              label: "پادکست",
            },
            component: () => import("@/views/pages/multiMedia/podcast/List"),
          },
          {
            path: "podcast/list",
            name: "PodcastList",
            meta: {
              requiresAuth: false,
              label: "همه ی پادکست ها",
            },
            component: () => import("@/views/pages/multiMedia/podcast/index"),
          },
          {
            path: "podcast/details/:id",
            name: "PodcastDetails",
            meta: {
              requiresAuth: false,
              label: "صفحه داخلی صوت",
            },
            component: () => import("@/views/pages/multiMedia/podcast/Details"),
          },
          {
            path: "gallery/:id",
            name: "Gallery",
            meta: {
              requiresAuth: false,
              label: "تصاویر",
            },
            component: () => import("@/views/pages/multiMedia/gallery/index"),
          },
          {
            path: "image",
            name: "ImageDetails",
            meta: {
              requiresAuth: false,
              label: "تصاویر",
            },
            component: () => import("@/views/pages/multiMedia/gallery/Details"),
          },
          {
            path: "image/list",
            name: "ImageList",
            meta: {
              requiresAuth: false,
              label: "تصاویر",
            },
            component: () => import("@/views/pages/multiMedia/gallery/List"),
          },
        ],
      },
      {
        path: "aboutOrganization/:id",
        name: "AboutOrganization",
        meta: {
          requiresAuth: false,
          label: "درباره سازمان",
        },
        component: () => import("@/views/pages/about"),
      },
      {
        path: "subject/:id",
        name: "SubjectsDetail",
        meta: {
          requiresAuth: false,
          label: "مطالب",
        },
        component: () => import("@/views/pages/subject"),
      },
      {
        path: "contact-us",
        name: "CountactUs",
        meta: {
          requiresAuth: false,
          label: "تماس با ما",
        },
        component: () => import("@/views/pages/contact-us"),
      },
      {
        path: "search/:key",
        name: "Search",
        meta: {
          requiresAuth: false,
          label: "جستجو",
        },
        component: () => import("@/views/pages/Search"),
      },
      // end of Container
    ],
  },

  // other Pages - without container

  {
    path: "/pages",
    redirect: "/pages/404",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "404",
        name: "Page404",
        component: Page404,
      },
      {
        path: "403",
        name: "Page403",
        component: Page403,
      },
      {
        path: "500",
        name: "Page500",
        component: Page500,
      },
      {
        path: "underConstruction",
        name: "PageUnderConstruction",
        component: PageUnderConstruction,
      },
    ],
  },

  {
    path: "*",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({
    behavior: "smooth",
    y: 0,
    x: 0,
  }),
  routes,
});

router.beforeEach((to, from, next) => GlobalGuards.beforeEach(to, from, next));
router.afterEach((to, from) => GlobalGuards.afterEach(to, from));

export default router;
